import { useAuth } from '../../context/AuthContext';
import AppShell from './AppShell';

/**
 * Wraps public discovery pages with the client app shell (sidebar + header)
 * when a client is signed in. Guests keep the lightweight public layout.
 */
const ClientSessionLayout = ({ publicLayout, children, mainClassName = 'min-w-0 flex-1 overflow-auto' }) => {
  const { isAuthenticated, role } = useAuth();

  if (isAuthenticated && role === 'CLIENT') {
    return <AppShell mainClassName={mainClassName}>{children}</AppShell>;
  }

  return publicLayout;
};

export default ClientSessionLayout;
